/** Read session_id from the URL. SSR-safe — never prefers window over searchParams. */
export function readUrlSessionId(
    searchParams: Pick<URLSearchParams, "get">
): string | null {
    const fromParams = searchParams.get("session_id");
    if (fromParams) return fromParams;
    if (typeof window === "undefined") return null;
    // Fallback for pre-hydration when searchParams is empty but the URL already has a param.
    return new URLSearchParams(window.location.search).get("session_id");
}
